module.exports = __webpack_public_path__ + "img/vi_vn.9e9802c9.png";